// extracted by mini-css-extract-plugin
module.exports = {"Plan":"EledoPricingPlan_Plan__2yj1v","PlanTitle":"EledoPricingPlan_PlanTitle__1ya__","PlanLine":"EledoPricingPlan_PlanLine__2P7HT"};